export var HTTP_METHODS;
(function(HTTP_METHODS) {
    HTTP_METHODS["GET"] = "GET";
    HTTP_METHODS["POST"] = "POST";
    HTTP_METHODS["PUT"] = "PUT";
    HTTP_METHODS["DELETE"] = "DELETE";
    HTTP_METHODS["PATCH"] = "PATCH";
})(HTTP_METHODS || (HTTP_METHODS = {}));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnVtcy9odHRwX21ldGhvZHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gSFRUUF9NRVRIT0RTIHtcbiAgR0VUID0gJ0dFVCcsXG4gIFBPU1QgPSAnUE9TVCcsXG4gIFBVVCA9ICdQVVQnLFxuICBERUxFVEUgPSAnREVMRVRFJyxcbiAgUEFUQ0ggPSAnUEFUQ0gnLFxufVxuIl0sIm5hbWVzIjpbIkhUVFBfTUVUSE9EUyJdLCJtYXBwaW5ncyI6IjtVQUFZQTs7Ozs7O0dBQUFBLGlCQUFBQSJ9